import { useEffect, useState } from "react";
import "./navbar.css";
import SideNavbarTop from "../side-navbar/side-navbar-top/side-navbar-top";
import YouTubeIcon from "@mui/icons-material/YouTube";
import Tooltip from "@mui/material/Tooltip";

const pages = [
  { name: "", path: "#infoPage" },
  { name: "Experience", path: "#experience" },
  { name: "Expertise", path: "#expertise" },
  { name: "Projects", path: "#projects" },
  { name: "Education", path: "#education" },
  { name: "Contact", path: "#contact" },
];

function NavBar() {
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [activeSection, setActiveSection] = useState("");

  const OFFSET_ONE = 110;
  const OFFSET_DESKTOP_PROJECT = 30;
  const OFFSET_MOBILE_PROJECT = 50;

  const toggleNav = () => {
    setIsMenuActive(!isMenuActive);
  };

  const scrollWithOffset = (el: HTMLElement, offset: number) => {
    const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  const handleScrollClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    selector: string,
    offset: number,
    closeMenu = false
  ) => {
    e.preventDefault();

    const el = document.querySelector(selector) as HTMLElement | null;
    if (!el) return;

    scrollWithOffset(el, offset);

    if (closeMenu) {
      setIsMenuActive(false);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY <= 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const sections = pages.map((page) => document.querySelector(page.path));
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries.find((entry) => entry.isIntersecting);
        if (entry) {
          const currentSection = entry.target.getAttribute("id");
          if (currentSection === "infoPage") {
            setActiveSection("");
          } else {
            setActiveSection(`#${currentSection}`);
          }
        }
      },
      { threshold: 0.5 }
    );

    sections.forEach((section) => {
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      sections.forEach((section) => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  return (
    <nav data-aos="fade-down" data-aos-delay="1000">
      <div className="navbarTop">
        <SideNavbarTop isHiddenOnScroll={true} />
      </div>

      <div className={`logo ${isVisible ? "hidden" : "visible"}`}>
        <a
          href="#infoPage"
          onClick={(e) => handleScrollClick(e, "#infoPage", OFFSET_ONE)}
        >
          <h1>MUDITH PERERA</h1>
        </a>
      </div>

      <ul className={isMenuActive ? "active" : ""}>
        {pages.map((page) => (
          <li key={page.name}>
            {page.name === "Projects" ? (
              <a
                href={page.path}
                onClick={(e) =>
                  handleScrollClick(e, page.path, OFFSET_DESKTOP_PROJECT)
                }
                className={activeSection === page.path ? "active-item" : ""}
              >
                {page.name}
              </a>
            ) : (
              <a
                href={page.path}
                onClick={(e) => handleScrollClick(e, page.path, OFFSET_ONE)}
                className={activeSection === page.path ? "active-item" : ""}
              >
                {page.name}
              </a>
            )}
          </li>
        ))}

        <li>
          <Tooltip
            title="Youtube"
            slotProps={{
              tooltip: {
                sx: {
                  color: "black",
                  backgroundColor: "white",
                },
              },
            }}
          >
            <span
              className="tilt-shaking-yt"
              onClick={() =>
                window.open("https://www.youtube.com/@MM.Mudith", "_blank")
              }
            >
              <YouTubeIcon color="error" fontSize="large" />
            </span>
          </Tooltip>
        </li>
      </ul>

      <div
        className={`hamburger ${isMenuActive ? "hamburger-active" : ""}`}
        onClick={toggleNav}
      >
        <span className="line"></span>
        <span className="line"></span>
        <span className="line"></span>
      </div>

      <div className={`menubar ${isMenuActive ? "active" : ""}`}>
        <ul className="mobile">
          <li onClick={toggleNav}>
            <div className="logo">
              <a
                href="#infoPage"
                onClick={(e) =>
                  handleScrollClick(e, "#infoPage", OFFSET_ONE, true)
                }
              >
                <h1>MUDITH PERERA</h1>
              </a>
            </div>
          </li>

          {pages.map((page) => (
            <li key={page.name}>
              {page.name === "Projects" ? (
                <a
                  href={page.path}
                  onClick={(e) =>
                    handleScrollClick(
                      e,
                      page.path,
                      OFFSET_MOBILE_PROJECT,
                      true
                    )
                  }
                  className={activeSection === page.path ? "active-item" : ""}
                >
                  {page.name}
                </a>
              ) : (
                <a
                  href={page.path}
                  onClick={(e) =>
                    handleScrollClick(e, page.path, OFFSET_ONE, true)
                  }
                  className={activeSection === page.path ? "active-item" : ""}
                >
                  {page.name}
                </a>
              )}
            </li>
          ))}

          <li>
            <Tooltip
              title="Youtube"
              slotProps={{
                tooltip: {
                  sx: {
                    color: "black",
                    backgroundColor: "white",
                  },
                },
              }}
            >
              <span
                style={{ width: "120px" }}
                className="tilt-shaking-yt-mobile"
                onClick={() =>
                  window.open("https://www.youtube.com/@MM.Mudith", "_blank")
                }
              >
                <YouTubeIcon color="error" fontSize="large" /> &nbsp;Youtube
              </span>
            </Tooltip>
          </li>

          <li> &nbsp;</li>

          <li>
            <div className="navbarTop">
              <SideNavbarTop isHiddenOnScroll={false} />
            </div>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default NavBar;